import { useMemo } from "react";
import { useFeature } from "store/selectors/hooks";
import {
    SmtpCredentialStatus,
    useGetSmtpCredentialForUserQuery,
    useGetUserMailboxesQuery,
    UserMailboxStatus,
} from "generated/graphql";

export function useUserMailboxes() {
    const enabled = useFeature("mailboxSync");
    const query = useGetUserMailboxesQuery({}, { enabled });

    const mailboxes = useMemo(() => {
        return query.data?.getUserMailboxes ?? [];
    }, [query.data]);

    const activeMailbox = useMemo(() => {
        return mailboxes.find(m => m.status === UserMailboxStatus.Active);
    }, [mailboxes]);

    const hasActiveMailbox = !!activeMailbox;

    return {
        mailboxes,
        activeMailbox,
        hasActiveMailbox,
        refetch: query.refetch,
        enabled,
    };
}

export function useHasActiveSmtpCredential(): boolean {
    const query = useGetSmtpCredentialForUserQuery({});
    return query.data?.getSmtpCredentialForUser?.status === SmtpCredentialStatus.Active;
}
